import "./OrdersTable.css";
import {
  useExpanded,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";

import { CaseDocumentAdmin, LabOrder } from "pwapi";

import OrdersColumns, {
  withCellDataAttrs,
  withOrderStatusRowProp,
} from "./OrdersColumns";
import OrdersTableView from "./OrdersTableView";

type OrdersTableProps = {
  caseStatus: string;
  documents: CaseDocumentAdmin[];
  orders: LabOrder[];
  columns: any[];
  ordersWithoutSlides?: LabOrder[];
  setPreviewDocumentId?: (documentId?: number) => void;
};

const OrdersTable = ({ columns, orders = [] }: OrdersTableProps) => {
  const { headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: orders,
      autoResetExpanded: false,
      defaultColumn: {
        sortDescFirst: true,
      },
      initialState: {
        sortBy: [{ id: "created_at", desc: false }],
      },
    },
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    withOrderStatusRowProp,
    withCellDataAttrs
  );

  return (
    <OrdersTableView
      headerGroups={headerGroups}
      rows={rows}
      prepareRow={prepareRow}
    />
  );
};

export default OrdersColumns(OrdersTable, {
  hasFlagReason: true,
  canCancel: true,
  canCompleteOrder: true,
  displayClipboardButton: false,
  printSlideFromOrderButton: true,
});
